import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import indiaStates from '../../../../../../../assets/js/india.state.list.json';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';

export interface User {
  name: string;
}
@Component({
  selector: 'app-edit-employee',
  templateUrl: './edit-employee.component.html',
  styleUrls: ['./edit-employee.component.css']
})

export class EditEmployeeComponent implements OnInit {

  matFormSize = '13px'
  editEmployeeForm: FormGroup;

  isShowSimno = false;
  isShowVendorName = false;
  selectState = ''
  selection = ''
  myControl = new FormControl();
  public stateSelect = indiaStates.IND;
  options: User[] = [];
  filteredOptions: Observable<User[]>;
  isShowImg: boolean = false
  strDate: any;

  purchDate: any;
  rcStrDate: any;
  shiftArr: any[] = []
  public stateData = []
  submitted = false;

  // public stateSelect = indiaStates.IND;
  public isLocMandatory: boolean = true;
  public editLocation: boolean = true;
  public employeeLocation = {};
  public locationData = {};

  minFromDate = new Date();
  maxToDate = new Date().setDate(2);
  //VendorInfos: any;
  shiftInformation: any = [];
  branchInformation: any[];
  public orgID;
  public employeeID;
  public profileImage: any;
  public branchUpdate: boolean = false;
  public profileUpdate: boolean = false;

  public updateValues = [];
  formSubmit: boolean = false;

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public route: ActivatedRoute,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService,
    public comService: CommonServices,
    public loader: LoaderService
  ) {
    this.orgID = this.storage.get('userInfo').orgID;
    this.route.paramMap.subscribe((params: any) => {
      this.employeeID = params.params.employeeID;
    });
  }

  ngOnInit(): void {

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
    this.getBranchList();
    this.getStateOptions();
    this.getListShift();
    this.addFormLoad();
    setTimeout(() => this.getEmployeeData(), 500);

  }

  displayFn(user: User): string {
    this.stateData = []
    this.stateData.push(user)
    // this.editEmployeeForm.value.patchValue({state:user}
    return user && user.name ? user.name : '';
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          this.branchInformation = [];
          res.data.filter((e) => {
            let option = { name: e.branchName, value: e.branchID };
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getListShift() {
    const obj = {
      orgID: this.orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.shiftInformation = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeBrach(val) {
    // console.log(val, this.shiftInformation)
    this.shiftArr = []
    this.shiftInformation.forEach((element, i) => {
      // console.log(element.branch == val)
      if (element.branch == val) {
        this.shiftArr.push(element)
      }
    });
    if (this.branchUpdate) this.fieldChange(val, 'branch', 'branch');
    // console.log(this.shiftArr)
  }
  getStateOptions() {
    this.stateSelect.forEach(element => {
      // console.log(element)
      this.options.push({ name: element })
    });
  }

  addFormLoad() {
    this.editEmployeeForm = new FormGroup({
      name: new FormControl('', [Validators.required]),  //, Validators.minLength(5)
      empRefID: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      dob: new FormControl(''),
      gender: new FormControl('', [Validators.required]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      emergencyContact: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      bloodGroup: new FormControl(''),
      address: new FormControl('',),
      city: new FormControl('',),
      state: new FormControl('',),
      country: new FormControl({ value: 'India', disabled: true }),
      pincode: new FormControl('', [Validators.pattern('[0-9]\\d{5}')]),
      transportType: new FormControl('', [Validators.required]),
      department: new FormControl('', [Validators.required]),
      workLocation: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
      tripType: new FormControl ('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),
      shift: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required]),
      empProfile: new FormControl(''),
      seatType: new FormControl(''),
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.editEmployeeForm.controls[controlName].hasError(errorName);
  }
  getEmployeeData() {
    const obj = {
      orgID: this.orgID,
      employeeID: this.employeeID
    };
    this.api.transportManagerEmployeeList(obj).then((res: any) => {
      if (res.status == 'success') {
        const data = res.data[0];
        console.log("trip type data::::::", data);
        if (data?.location?.lat == null && data?.location?.lng == null) {
          data.location = '';
        }
        this.setValueEditEmployeeForm(data);
        this.selection = data.gender
        //this.profileImage = data.profile
        // this.selectState = data.state
        this.myControl.setValue(data.state);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setValueEditEmployeeForm(data) {
    console.log("log data::::::", data);
    
    this.editEmployeeForm.patchValue({
      name: data.name,
      empRefID: '' + data.empRefID,
      area: data?.area ? data.area : '',
      email: data?.email,
      dob: data?.dob ? (data?.dob == 1 ? new Date(631132200000) : new Date(data?.dob)) : '',
      gender: data?.gender ? this.comService.convertTitleCase(data?.gender) : '',
      mobile: data?.mobile,
      emergencyContact: data?.emergencyContact,
      bloodGroup: data?.bloodGroup ? String(data.bloodGroup).toLowerCase() : '',
      address: data?.address || '',
      city: data?.city || '',
      state: data?.state || '',
      country: data?.country ? data.country : 'India',
      pincode: data?.pincode || '',
      transportType: data?.transportType,
      department: data?.department || '',
      workLocation: data?.workLocation || '',
      branch: data?.branch || '',
      shift: data?.shift || '',
      location: data?.location ? data?.location?.name || '' : '',
      empProfile: data.empProfile || '',
      seatType: data.seatType ? data.seatType : 'no',
      tripType: data?.tripType || '',
    });
    if (data['empProfile']) this.profileImage = `${data['empProfile']}?time=${Date.now()}`;
    if (data.seatType == 'yes') {
      if (data.gender == 'Female') this.editEmployeeForm.addControl('pregnancy', new FormControl(data.pregnancy));
      this.editEmployeeForm.addControl('speciallyAbled', new FormControl(data.speciallyAbled));
    }
    this.locationData = { ...data.location };
    this.employeeLocation = data.location;
    // this.profileImage = data.profile;
    this.onChangeBrach(data.branch);
    this.branchUpdate = true;
  }

  getLocation(obj) {
    this.employeeLocation = { ...obj };
    this.fieldChange(this.employeeLocation, 'location', 'location');
  }

  /* update unique field*/
  fieldChange(e: any, type, field) {
    if (type == 'text' || type == 'textarea') {
      let value = e.target.value;
      if (field == 'email' && value != '') value = value.toLowerCase();
      if ((field == 'mobile' || field == 'emergencyContact' || field == 'pincode') && value != '') value = parseInt(value);
      this.updateField(field, value);
    }
    if (type == 'date' || type == 'dropdown' || type == 'radio') {
      let value = e.value;
      if (type == 'date') value = e && e.value && e.value != '' && e.value != 0 ? e.value.getTime() : 1;
      this.updateField(field, value);
    }
    if (type == 'checkbox' || type == 'location' || type == 'file' || type == 'branch' || type == "gender" || type == "seatType") {
      this.updateField(field, e);
    }
  }
  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
  }

  onChangeGender(value) {
    this.editEmployeeForm.controls.gender.patchValue(value);
    if (value == 'Female') {
      this.editEmployeeForm.addControl('pregnancy', new FormControl(''));
    }
    else {
      this.editEmployeeForm.removeControl('pregnancy');
    }
    this.fieldChange(value, 'gender', 'gender')
  }

  onChangeSeat(value) {
    this.editEmployeeForm.controls.seatType.patchValue(value);
    if (value == 'yes') {
      this.editEmployeeForm.addControl('speciallyAbled', new FormControl(''));
    }
    else {
      this.editEmployeeForm.removeControl('speciallyAbled');
      this.editEmployeeForm.removeControl('pregnancy');
    }
    this.fieldChange(value, 'seatType', 'seatType')

  }

  onSubmit() {
    this.formSubmit = true;
    this.submitted = true;
    if (!this.editEmployeeForm.valid) return this.comService.markFormGroupTouched(this.editEmployeeForm)

    if (this.editEmployeeForm.valid && this.updateValues && this.updateValues.length > 0) {
      const obj = {
        orgID: this.orgID,
        employeeID: this.employeeID
      };

      this.updateValues.filter((e) => {
        obj[e.field] = e.value;
      });
      
      if (this.profileUpdate === true && this.profileImage instanceof Blob) {
        obj['profile'] = this.profileImage;
        obj['profileType'] = 'Image';
      } else {
        delete obj['profile'];
        delete obj['profileType'];
      }

      let url = 'organization/employee/update';
      this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
        if (res['responseJSON']['status'] == 'success') {
          this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/employee/view-employee'])
        }
        if (res['responseJSON'].status == 'failure') {
          this.loader.hide();
          this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
        }
      })

      // this.api.transportManagerEmployeeUpdate(obj).then((res: any) => {
      //   if (res.status == 'success') {
      //     this.swal.swalFunction(res.status, res.status, res.message, 2000);
      //     this.router.navigate(['/organization/transport-manager/information/orgInfo/employee/view-employee'])
      //   }
      //   if (res.status == 'failure') {
      //     this.swal.swalFunction('error', res.status, res.message, 3000);
      //   }
      // }).catch((err) => {
      //   console.log(err);
      // });

    }
  }
  async handleUpload(event) {
    // const file = (event.target as HTMLInputElement).files?.[0]
    const file = event.target.files[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!file) return;
    const isValid = this.validateFile(file, allowedImageTypes, maxFileSize);
    if (!isValid) return;

    this.profileImage = await this.file.fileHandeleBase64(event);
    this.profileUpdate = true;
    this.fieldChange(file, 'file', 'empProfile');
    this.editEmployeeForm.controls.empProfile.patchValue(file);
  }
  validateFile(file, allowedImageTypes, maxFileSize) {
    if (!allowedImageTypes.includes(file.type)) {
      return this.showErrorMessage('Invalid file type. Only images are allowed.');
    }
    if (file.size > maxFileSize) {
      return this.showErrorMessage(`File size exceeds 1 MB`);
    }
    return true;
  }

  reUpload(field) {
    document.getElementById(field).click();
  }

  cancelImage() {
    this.profileImage = undefined;
    this.profileUpdate = false;
    this.editEmployeeForm.controls.empProfile.patchValue('');
    //update if profile is removed or replaced
    this.fieldChange('', 'file', 'empProfile');
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  onChangeBoxType(e) {
    this.isShowVendorName = false;
    this.isShowSimno = false;
    if (e.value == 'others') { this.isShowVendorName = true; }
    if (e.value == 'group10') { this.isShowSimno = true; }
  }
  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }
}

